import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://sakhxnkfqbojzgourmua.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNha2h4bmtmcWJvanpnb3VybXVhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg0OTk3NzUsImV4cCI6MjA5NDA3NTc3NX0.RJz3YjrEe2p4Mil_G5bO618nTixDKUuQ0N5lLMdcsJI'

export const supabase = createClient(supabaseUrl, supabaseKey)